import {createGlobalStyle} from 'styled-components';
import {normalize} from 'styled-normalize';

// eslint-disable-next-line eag/no-css-property
const BasicStyles = createGlobalStyle`
  /* Unlayered CSS beats every Tailwind layer, so normalize goes below the platform utilities. */
  @layer base {
    ${normalize}
  }

  @media print {
    @page {
      margin: 40px 0;
    }
    svg {
      page-break-inside: avoid;
    }
    body {
      margin: 0;
      padding: 0;
    }
  }

  img, svg, video, canvas, audio, iframe, embed, object {
   display: block;
  }

  body {
    min-height: 100vh;
    min-height: 100dvh;
    max-width: 100vw;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    background-color: ${({theme}) => theme.colors.general.white};
  }

  .svg-exterior-overlay, .svg-interior-overlay, .svg-paint-overlay {
    opacity: 0;
    transition: opacity 1s ease-in-out;

  }

  .svg-exterior-point, .svg-interior-point, .svg-paint-point {
    will-change: transform, opacity;
    transform-origin: center;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    transform: scale(0);
    opacity: 0;
  }
  .svg-exterior-point:hover,
  .svg-interior-point:hover {
    filter: drop-shadow(0px 0px 8px  #EF6F48);
    cursor: pointer;
  }

  .svg-paint-point-bg {
    transform-origin: center;
  }

  svg * {
    transform-box: fill-box;
  }
`;

export const GlobalStyles = () => <BasicStyles />;
